import { gql } from '@apollo/client';

export const FETCH_DRIFT_STATE = gql`
  query fetchOrganizationDriftState($organizationId: String!) {
    fetchOrganization(organizationId: $organizationId) {
      organization {
        id
        defaultDriftTolerancePercent
        defaultDriftCalculationMethod
        driftRecalculationState
        driftRecalculationStartedAt
        pendingDriftRecalc
        driftRecalculationSettledAt
        driftRecalculationSettledOutcome
      }
    }
  }
`;
